import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "overlay"]

  connect() {
    // Ensure the modal is hidden when first connected
    this.element.classList.add("hidden")

    // Listen for custom open event from trigger buttons
    this._boundOpen = this.open.bind(this)
    this.element.addEventListener('modal:open', this._boundOpen)
  }

  disconnect() {
    // Clean up listeners when disconnected
    this.element.removeEventListener('modal:open', this._boundOpen)
  }

  open() {
    // Show modal
    this.element.classList.remove("hidden")

    // Animate in
    requestAnimationFrame(() => {
      this.overlay.classList.remove("opacity-0")
      this.content.classList.remove("opacity-0", "translate-y-4", "sm:translate-y-0", "sm:scale-95")
      this.content.classList.add("opacity-100", "translate-y-0", "sm:scale-100")
    })

    // Focus the first button
    const firstButton = this.content.querySelector("button")
    if (firstButton) firstButton.focus()
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    // Animate out
    this.overlay.classList.add("opacity-0")
    this.content.classList.remove("opacity-100", "translate-y-0", "sm:scale-100")
    this.content.classList.add("opacity-0", "translate-y-4", "sm:translate-y-0", "sm:scale-95")

    // Hide after animation
    setTimeout(() => {
      this.element.classList.add("hidden")
    }, 200)
  }

  handleSubmit() {
    this.close()
  }

  get overlay() {
    return this.overlayTarget
  }

  get content() {
    return this.contentTarget
  }
}
